<template>
  <div class="py-4 container-fluid">
    <!-- ======= KATALOG ======= -->
    <div class="catalog mb-4">
      <div class="catalog-main">
        <div class="catalog-title">
          <span class="catalog-icon"><i class="fas fa-boxes"></i></span>
          <div>
            <h4>Master Item List</h4>
            <span>Katalog barang &amp; jasa yang dipakai saat membuat PR</span>
          </div>
        </div>
        <div class="catalog-stats">
          <div><b>{{ (itemStats.total || 0).toLocaleString('id-ID') }}</b><span>Total item</span></div>
          <div><b>{{ usedPct }}%</b><span>Pernah dipakai di PR</span><small>{{ (itemStats.used || 0).toLocaleString('id-ID') }} item</small></div>
          <div><b>{{ ((itemStats.total || 0) - (itemStats.used || 0)).toLocaleString('id-ID') }}</b><span>Belum pernah dipakai</span></div>
          <div><b>+{{ itemStats.this_month || 0 }}</b><span>Item baru bulan ini</span></div>
        </div>
        <div class="catalog-actions">
          <a class="btn btn-sm btn-outline-success mb-0" :href="exportUrl('export-excel/item-list-proc')" target="_BLANK"><i class="fas fa-file-excel"></i> Export Excel</a>
          <a class="btn btn-sm btn-outline-primary mb-0" :href="exportUrl('print-pdf/item-list-proc')" target="_BLANK"><i class="fas fa-file-pdf"></i> Export PDF</a>
        </div>
      </div>

      <!-- panel import -->
      <div class="import-panel">
        <span class="import-title"><i class="fas fa-file-import"></i> Import dari Excel</span>
        <div class="import-steps">
          <a class="istep" :href="apiUrl + 'export-excel/item-list-proc-template'" target="_BLANK">
            <span class="istep-no">1</span><span><b>Download template</b><small>sudah ada dropdown unit, group, kategori</small></span><i class="fas fa-download"></i>
          </a>
          <div class="istep istep-static">
            <span class="istep-no">2</span><span><b>Isi data di Excel</b><small>kode item dibuat otomatis</small></span><i class="fas fa-pen"></i>
          </div>
          <button type="button" class="istep istep-main" @click="openImport()">
            <span class="istep-no">3</span><span><b>Upload &amp; cek</b><small>pratinjau dulu sebelum disimpan</small></span><i class="fas fa-upload"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- kategori -->
    <div class="cat-strip mb-3">
      <button type="button" class="cat-tile" :class="{ on: !search.item_category }" @click="setCategory('')">
        <span class="ct-code">ALL</span><b>{{ (itemStats.total || 0).toLocaleString('id-ID') }}</b><small>Semua kategori</small>
      </button>
      <button v-for="(c, i) in itemStats.categories" :key="c.code || 'none'" type="button" class="cat-tile" :class="{ on: search.item_category == c.code && c.code }" :style="{ '--c': palette[i % palette.length] }" @click="setCategory(c.code)" :disabled="!c.code" :title="c.code ? 'Tampilkan kategori ' + c.name : 'Item tanpa kategori'">
        <span class="ct-code">{{ c.code || '-' }}</span><b>{{ Number(c.total).toLocaleString('id-ID') }}</b><small>{{ c.name || 'Tanpa kategori' }}</small>
        <span class="ct-bar"><span :style="{ width: (c.total / (itemStats.total || 1) * 100) + '%' }"></span></span>
      </button>
    </div>

    <div class=" row">
      <div class="col-12">
          <div class="card">
            <div class="card-header pb-2">
              <div class="row align-items-center">
                <div class="col-xl-5 col-lg-12 mb-2">
                  <div class="input-group">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cari kode, nama item, spesifikasi, ukuran..." v-model="search.q" @input="onSearch()">
                  </div>
                </div>
                <div class="col-xl-7 col-lg-12 mb-2 d-flex flex-wrap justify-content-xl-end align-items-center gap-2">
                  <div class="btn-group btn-group-sm mb-0">
                    <button type="button" class="btn mb-0" :class="!search.item_group ? 'btn-dark' : 'btn-outline-dark'" @click="setGroup('')">Semua Group</button>
                    <button v-for="g in itemStats.groups" :key="g.code" type="button" class="btn mb-0" :class="search.item_group == g.code ? 'btn-dark' : 'btn-outline-dark'" @click="setGroup(g.code)">{{ g.code }} · {{ Number(g.total).toLocaleString('id-ID') }}</button>
                  </div>
                  <argon-button variant="gradient" color="secondary" size="sm" @click="filter()"><i class="fa fa-filter fa-sm"></i> Filter</argon-button>
                  <argon-button variant="gradient" color="success" size="sm" @click="create()"><i class="fa fa-plus fa-sm"></i> Add New</argon-button>
                </div>
              </div>
              <div v-if="activeChips.length">
                <span v-for="chip in activeChips" :key="chip.key" class="badge bg-light text-dark me-2 filter-chip" @click="clearFilter(chip.key)">{{ chip.label }} <i class="fa fa-times ms-1"></i></span>
                <span class="text-xs text-primary filter-chip" @click="resetFilter()">Hapus semua filter</span>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM CODE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM NAME</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">SPECIFICATION</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">SIZE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">UNIT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM GROUP</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM CATEGORY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM SUB CATEGORY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DIPAKAI DI PR</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED AT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED BY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!loading && !table.data.length"><td colspan="13" class="text-center text-sm text-secondary py-5">Tidak ada item yang cocok dengan pencarian</td></tr>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ (pagination.page - 1) * 100 + i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="item-code">{{ row.item_code }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.item_name }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.specification }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.size }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.unit }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.item_group }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase d-block">  {{ row.item_category }} </span>
                        <span class="text-xxs text-secondary" v-if="categoryName(row.item_category)">{{ categoryName(row.item_category) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.item_sub_category }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <template v-if="row.pr_count">
                          <span class="usage-badge">{{ row.pr_count }}x</span>
                          <span class="text-xxs text-secondary d-block">terakhir {{ moment(row.last_used).locale('id').format('D MMM YYYY') }}</span>
                        </template>
                        <span v-else class="usage-none">Belum dipakai</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ moment(row.created_at).locale('id').format('LL') }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">  {{ row.created_by }} </span>
                      </td>
                      <td class="align-middle text-center">
                        <i class="fas fa-edit fa-sm" aria-hidden="true" title="Edit data ini" style="cursor: pointer; margin-right: 20px;" @click="edit(row.id)"></i>
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus data ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <!-- <span class="font-weight-bold text-danger ">TOTAL WORKING HOUR : {{ totalWorkingHour }} Hour {{ totalWorkingMinutes }} Minutes</span> -->
              </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Item Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="itemData.item_name" style="text-transform:uppercase">
        <label for="example-text-input" class="form-control-label mt-3">Specification <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Specification" v-model="itemData.specification" style="text-transform:uppercase">
        <label for="example-text-input" class="form-control-label mt-3">Size <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Size" v-model="itemData.size" style="text-transform:uppercase">
        <label for="example-text-input" class="form-control-label mt-3">Unit <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="itemData.unit" style="text-transform:uppercase">
          <option v-for="(u, k) in tableUom.data" :key="k" :value="u.code">{{ u.name }}</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Item Group <span style="color: red;">*</span></label>
        <multiselect v-model="itemData.item_group" :options="tableItemGroup.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Item Group" label="group_name" track-by="group_name" :preselect-first="true" @keyup="getItemGroup" :custom-label="nameWithGrpCode" :disabled="form.title != 'Add Data'">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Item Category </label>
        <multiselect v-model="itemData.item_category" :options="tableItemCategory.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Item Category" label="category_name" track-by="category_name" :preselect-first="true" @keyup="getItemCategory" :custom-label="nameWithCatCode" :disabled="form.title != 'Add Data'">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Item Sub Category </label>
        <multiselect v-model="itemData.item_sub_category" :options="tableItemSubCategory.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Item Sub Category" label="sub_category_name" track-by="sub_category_name" :preselect-first="true" @keyup="getItemSubCategory" :custom-label="nameWithSubCode" :disabled="form.title != 'Add Data'">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-4"> 
        </div>
        <div class="col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = true">Close</argon-button>
        </div>
        <div class="col-2">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Item Code </label>
        <input type="text" class="form-control" placeholder="Item Code" v-model="search.item_code" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Item Name </label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="search.item_name" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Specification </label>
        <input type="text" class="form-control" placeholder="Specification" v-model="search.specification" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Size </label>
        <input type="text" class="form-control" placeholder="Size" v-model="search.size" v-on:keyup.enter="get()">

        <!-- <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date"/> -->
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-4"> 
        </div>
        <div class="col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="resetFilter()">Clear</argon-button>
        </div>
        <div class="col-2">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="reload()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>


  <!-- =======  MODAL IMPORT EXCEL ======= -->
  <div class="container">
    <vue-final-modal v-model="importer.show" classes="modal-container" content-class="modal-content modal-import" :z-index="10000" :click-to-close="!importer.loading">
      <div class="d-flex justify-content-between align-items-center">
        <span class="modal__title"><i class="fas fa-file-import text-success"></i> Import Master Item dari Excel</span>
        <i style="cursor: pointer;" class="fa fa-times" @click="!importer.loading && (importer.show = false)"></i>
      </div>
      <hr class="my-2">

      <!-- selesai disimpan -->
      <div v-if="importer.result && importer.result.saved.length" class="text-center py-3">
        <div class="done-icon"><i class="fas fa-check"></i></div>
        <h5 class="mt-3 mb-1">{{ importer.result.saved.length }} item berhasil ditambahkan</h5>
        <p class="text-sm text-secondary">Kode item sudah dibuat otomatis oleh sistem.</p>
        <div class="saved-list text-start">
          <div v-for="sv in importer.result.saved" :key="sv.item_code" class="saved-row"><b>{{ sv.item_code }}</b><span>{{ sv.item_name }}</span></div>
        </div>
        <div class="d-flex justify-content-center gap-2 mt-3">
          <argon-button variant="gradient" color="secondary" size="sm" @click="resetImport()">Import File Lain</argon-button>
          <argon-button variant="gradient" color="success" size="sm" @click="importer.show = false">Selesai</argon-button>
        </div>
      </div>

      <template v-else>
        <!-- pilih file -->
        <label class="drop-zone" :class="{ dragging: importer.dragging, filled: importer.file }"
               @dragover.prevent="importer.dragging = true" @dragleave.prevent="importer.dragging = false" @drop.prevent="onDrop">
          <input type="file" accept=".xlsx,.xls" class="d-none" @change="onPickFile">
          <i class="fas" :class="importer.file ? 'fa-file-excel text-success' : 'fa-cloud-upload-alt'"></i>
          <span v-if="importer.file"><b>{{ importer.file.name }}</b> · {{ (importer.file.size / 1024).toFixed(0) }} KB <small class="d-block">klik untuk ganti file</small></span>
          <span v-else><b>Tarik file Excel ke sini</b> atau klik untuk memilih<small class="d-block">Gunakan template dari tombol "Download template" (maks. 2.000 baris, 5 MB)</small></span>
        </label>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <a class="text-xs" :href="apiUrl + 'export-excel/item-list-proc-template'" target="_BLANK"><i class="fas fa-download"></i> Download template</a>
          <argon-button variant="gradient" color="info" size="sm" :disabled="!importer.file || importer.loading" @click="runImport(false)">
            <span v-if="importer.loading && !importer.committing"><i class="fas fa-spinner fa-spin"></i> Mengecek...</span>
            <span v-else><i class="fas fa-search"></i> Cek File</span>
          </argon-button>
        </div>

        <div v-if="importer.error" class="alert-box mt-3"><i class="fas fa-exclamation-triangle"></i> {{ importer.error }}</div>

        <!-- pratinjau -->
        <template v-if="importer.result">
          <div class="preview-summary mt-3">
            <div><b>{{ importer.result.total }}</b><span>baris data</span></div>
            <div class="ps-ok"><b>{{ importer.result.valid }}</b><span>siap disimpan</span></div>
            <div class="ps-bad" :class="{ zero: !importer.result.invalid }"><b>{{ importer.result.invalid }}</b><span>bermasalah</span></div>
            <label class="ps-toggle" v-if="importer.result.invalid"><input type="checkbox" v-model="importer.onlyErrors"> Tampilkan yang bermasalah saja</label>
          </div>
          <div class="preview-table">
            <table class="table table-sm mb-0">
              <thead>
                <tr><th>Baris</th><th>Item Name</th><th>Spec</th><th>Size</th><th>Unit</th><th>Group</th><th>Kat.</th><th>Sub</th><th>Status</th></tr>
              </thead>
              <tbody>
                <tr v-for="r in previewRows" :key="r.line" :class="{ 'row-bad': r.errors.length }">
                  <td>{{ r.line }}</td>
                  <td>{{ r.input.item_name }}</td>
                  <td>{{ r.input.specification }}</td>
                  <td>{{ r.input.size }}</td>
                  <td>{{ r.data.unit || r.input.unit }}</td>
                  <td>{{ r.data.item_group || r.input.item_group }}</td>
                  <td>{{ r.data.item_category || '-' }}</td>
                  <td>{{ r.data.item_sub_category || '-' }}</td>
                  <td class="status-cell">
                    <span v-if="!r.errors.length" class="st-ok"><i class="fas fa-check-circle"></i> OK</span>
                    <span v-for="(e, k) in r.errors" :key="k" class="st-bad d-block"><i class="fas fa-times-circle"></i> {{ e }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-if="importer.result.invalid" class="text-xs text-danger mt-2 mb-0">
            <i class="fas fa-info-circle"></i> Perbaiki baris bermasalah di file Excel (nomor baris sesuai Excel), simpan, lalu klik "Cek File" lagi. Data hanya bisa disimpan kalau semua baris sudah OK.
          </p>
        </template>

        <div class="d-flex justify-content-end gap-2 mt-3">
          <argon-button variant="gradient" color="secondary" size="sm" :disabled="importer.loading" @click="importer.show = false">Batal</argon-button>
          <argon-button variant="gradient" color="success" size="sm" :disabled="!canCommit" @click="runImport(true)">
            <span v-if="importer.committing"><i class="fas fa-spinner fa-spin"></i> Menyimpan...</span>
            <span v-else><i class="fas fa-save"></i> Simpan {{ importer.result ? importer.result.valid : '' }} Item</span>
          </argon-button>
        </div>
      </template>
    </vue-final-modal>
  </div>
</template>

<script>

import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import Multiselect from 'vue-multiselect'
import 'vue3-toastify/dist/index.css';
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
import BasePagination from "@/components/BasePagination";
var moment = require('moment');

const EMPTY_SEARCH = { q: '', item_category: '', item_group: '', item_code: '', item_name: '', specification: '', size: '' };
import masterItemList from '@/services/procurement/masterItemList.service';
import materialGroupPR from '@/services/procurement/materialGroupPR.service';
import itemCategory from '@/services/procurement/itemCategory.service';
import itemSubCategory from '@/services/procurement/itemSubCategory.service';
import unitOfMeasurement from '@/services/unitOfMeasurement.service';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    Multiselect,
    // flatPickr,
    BasePagination
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      tableItemGroup: {
        data: []
      },
      tableItemCategory: {
        data: []
      },
      tableItemSubCategory: {
        data: []
      },
      tableUom: {
        data: []
      },

      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      itemData: {},
      search: { ...EMPTY_SEARCH },
      searchTimer: null,
      requestSeq: 0,
      loading: false,
      itemStats: { total: 0, used: 0, this_month: 0, groups: [], categories: [] },
      palette: ['#5e72e4', '#11cdef', '#2dce89', '#fb6340', '#f5365c', '#8965e0', '#fbb140', '#1171ef', '#ff7aa2', '#344767', '#8392ab'],
      importer: { show: false, file: null, dragging: false, loading: false, committing: false, error: '', result: null, onlyErrors: false },
      searchMenu: '',
      apiUrl :config.apiUrl,
      totalWorkingHour: '',
      totalWorkingMinutes: '',

    };
  },
  computed: {
    usedPct() {
      return this.itemStats.total ? Math.round(this.itemStats.used / this.itemStats.total * 100) : 0;
    },
    activeChips() {
      const labels = { item_code: 'Kode', item_name: 'Nama', specification: 'Spec', size: 'Size' };
      return Object.keys(labels).filter(k => this.search[k]).map(k => ({ key: k, label: labels[k] + ': ' + this.search[k] }));
    },
    previewRows() {
      const rows = this.importer.result ? this.importer.result.rows : [];
      return this.importer.onlyErrors ? rows.filter(r => r.errors.length) : rows;
    },
    canCommit() {
      const r = this.importer.result;
      return !!(r && r.ok && r.valid > 0 && r.invalid == 0 && !this.importer.loading);
    },
  },
  mounted(){
    this.get();
    this.getStats();
    this.getUom();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLang ({ project_number, project_name }) {
      return `${project_number} | ${project_name}`
    },
    getUom(){
      let context = this;
      Api(context, unitOfMeasurement.index()).onSuccess(function(response) {
          context.tableUom.data = response.data.data.data;
      }).onError(function(error) {
          if (error.response.status == 404) {
              context.tableUom.data = [];
          }
      })
      .call()
    },
    get(param){
      let context = this;               
      const seq = ++context.requestSeq;
      context.loading = true;
      Api(context, masterItemList.index({ ...this.search, page: context.pagination.page })).onSuccess(function(response) {
          if (seq != context.requestSeq) return;
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {
          if (seq != context.requestSeq) return;
          context.table.data = [];
          context.pagination.page_count = 1;
          // 404 = tidak ada item yang cocok, bukan error
          if (!error.response || error.response.status != 404) {
              context.notify('Data Retrieved Failed', 'error')
          }
      }).onFinish(function() {
         context.formFilter.show  = false;
         if (seq == context.requestSeq) context.loading = false;
      })
      .call()
    },
    getItemGroup(param){
      let context = this;        
      Api(context, materialGroupPR.getMaterialGroupPR({search: param.target.value})).onSuccess(function(response) {    
          context.tableItemGroup.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableItemGroup.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    nameWithGrpCode ({ material_group_code, group_name }) {
      return `${material_group_code} - ${group_name}`
    },
    getItemCategory(param){
      let context = this;        
      Api(context, itemCategory.getMaterialCategoryPR({search: param.target.value})).onSuccess(function(response) {    
          context.tableItemCategory.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableItemCategory.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    nameWithCatCode ({ category_code, category_name }) {
      return `${category_code} - ${category_name}`
    },
    getItemSubCategory(param){
      let context = this;        
      Api(context, itemSubCategory.getSubCategory({search: param.target.value})).onSuccess(function(response) {    
          context.tableItemSubCategory.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableItemSubCategory.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    nameWithSubCode ({ sub_category_code, sub_category_name }) {
      return `${sub_category_code} - ${sub_category_name}`
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add          = true;
      this.form.show         = true;
      this.form.title        = "Add Data";
      this.itemData = {};
    },
    edit(id) {
      let context = this;               
      Api(context, masterItemList.show(id)).onSuccess(function(response) {
          context.itemData                   = response.data.data.data;
          context.itemData.item_group        = response.data.data.dataItemGroup;
          context.itemData.item_category     = response.data.data.dataItemCategory;
          context.itemData.item_sub_category = response.data.data.dataItemSubCategory;
          context.form.show                  = true;
          context.form.title                 = 'Edit Data';   
      })
      .call()        
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.itemData.item_name != undefined && context.itemData.specification != undefined && context.itemData.size != undefined && context.itemData.unit != undefined && context.itemData.item_group != undefined) {
        formData.append('item_name', context.itemData.item_name);
        formData.append('specification', context.itemData.specification);
        formData.append('size', context.itemData.size);
        formData.append('unit', context.itemData.unit);
        formData.append('item_group', JSON.stringify(context.itemData.item_group));
        formData.append('item_category', (JSON.stringify(context.itemData.item_category) == undefined) ? '' : JSON.stringify(context.itemData.item_category));
        formData.append('item_sub_category', (JSON.stringify(context.itemData.item_sub_category) == undefined) ? '' : JSON.stringify(context.itemData.item_sub_category));
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, masterItemList.create(formData));
      } else {
          api = Api(context, masterItemList.update(this.itemData.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;
        Api(context, masterItemList.delete(id)).onSuccess(function(response) {
            context.get();
            context.getStats();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    filesChange(e) {
        this.itemData.attachment = e.target.files[0];
    },
    getStats() {
      let context = this;
      Api(context, masterItemList.stats()).onSuccess(function(response) {
        context.itemStats = response.data.data;
      }).call();
    },
    reload() {
      this.pagination.page = 1;
      this.get();
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.reload(), 400);
    },
    setCategory(code) {
      this.search.item_category = code;
      this.reload();
    },
    setGroup(code) {
      this.search.item_group = code;
      this.reload();
    },
    clearFilter(key) {
      this.search[key] = '';
      this.reload();
    },
    resetFilter() {
      this.search = { ...EMPTY_SEARCH };
      this.formFilter.show = false;
      this.reload();
    },
    categoryName(code) {
      const c = (this.itemStats.categories || []).find(x => x.code == code);
      return c && code ? c.name : '';
    },
    exportUrl(path) {
      const keys = ['item_code', 'item_name', 'specification', 'size'];
      return this.apiUrl + path + '?' + keys.map(k => k + '=' + encodeURIComponent(this.search[k] || '')).join('&');
    },
    // ===== import Excel =====
    openImport() {
      this.resetImport();
      this.importer.show = true;
    },
    resetImport() {
      Object.assign(this.importer, { file: null, dragging: false, loading: false, committing: false, error: '', result: null, onlyErrors: false });
    },
    setImportFile(file) {
      if (!file) return;
      if (!/\.(xlsx|xls)$/i.test(file.name)) {
        this.importer.error = 'Format file harus .xlsx atau .xls (pakai template).';
        return;
      }
      this.importer.file = file;
      this.importer.error = '';
      this.importer.result = null;
    },
    onPickFile(e) {
      this.setImportFile(e.target.files[0]);
      e.target.value = '';
    },
    onDrop(e) {
      this.importer.dragging = false;
      this.setImportFile(e.dataTransfer.files[0]);
    },
    // commit=false: cek & pratinjau, commit=true: simpan
    runImport(commit) {
      let context = this;
      const formData = new FormData();
      formData.append('file', this.importer.file);
      formData.append('commit', commit ? '1' : '0');
      this.importer.loading = true;
      this.importer.committing = commit;
      this.importer.error = '';
      Api(context, masterItemList.import(formData)).onSuccess(function(response) {
        const res = response.data.data;
        if (!res.ok && !res.rows) {
          context.importer.error = res.message;
          context.importer.result = null;
          return;
        }
        context.importer.result = res;
        context.importer.onlyErrors = res.invalid > 0;
        if (!res.ok) {
          context.importer.error = res.message;
        }
        if (commit && res.saved && res.saved.length) {
          context.notify(res.saved.length + ' item berhasil diimport', 'success');
          context.get();
          context.getStats();
        }
      }).onError(function() {
        context.importer.error = 'Upload gagal. Coba lagi atau cek koneksi.';
      }).onFinish(function() {
        context.importer.loading = false;
        context.importer.committing = false;
      }).call();
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll {
  overflow: auto;
  max-height: 600px;
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
/* ===== katalog (header) ===== */
.catalog { display: grid; grid-template-columns: 1.6fr 1fr; gap: 16px; }
@media (max-width: 1200px) { .catalog { grid-template-columns: 1fr; } }
.catalog-main, .import-panel { background: #fff; border-radius: 20px; padding: 20px 22px; box-shadow: 0 8px 24px rgba(52, 71, 103, .08); }
.catalog-main { display: flex; flex-direction: column; gap: 16px; border-top: 5px solid #fb6340; }
.catalog-title { display: flex; align-items: center; gap: 14px; }
.catalog-title h4 { margin: 0; font-weight: 800; color: #344767; }
.catalog-title span { font-size: .8rem; color: #8392ab; }
.catalog-icon { width: 50px; height: 50px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 22px; color: #fff; background: linear-gradient(135deg, #fbb140, #fb6340); box-shadow: 0 6px 14px rgba(251, 99, 64, .3); }
.catalog-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; }
@media (max-width: 768px) { .catalog-stats { grid-template-columns: repeat(2, 1fr); row-gap: 12px; } }
.catalog-stats div { display: flex; flex-direction: column; padding: 0 16px; border-left: 2px dotted #e3e8ef; }
.catalog-stats div:first-child { border-left: none; padding-left: 0; }
.catalog-stats b { font-size: 1.6rem; font-weight: 800; color: #344767; line-height: 1.15; }
.catalog-stats span { font-size: .72rem; font-weight: 700; color: #67748e; }
.catalog-stats small { font-size: .65rem; color: #8392ab; }
.catalog-actions { display: flex; gap: 8px; flex-wrap: wrap; }

/* ===== panel import ===== */
.import-panel { background: linear-gradient(150deg, #f0fdf6, #ffffff 60%); border: 1px solid #d3f2e2; }
.import-title { display: block; font-size: .8rem; font-weight: 800; color: #1a8f5c; text-transform: uppercase; letter-spacing: .05em; margin-bottom: 10px; }
.import-steps { display: flex; flex-direction: column; gap: 8px; }
.istep { display: flex; align-items: center; gap: 12px; border-radius: 12px; padding: 9px 12px; background: #fff; border: 1px solid #e3efe8; text-align: left; transition: transform .15s, box-shadow .15s; color: inherit; }
a.istep:hover, button.istep:hover { transform: translateX(3px); box-shadow: 0 6px 14px rgba(26, 143, 92, .12); }
.istep span:nth-child(2) { flex: 1; }
.istep b { display: block; font-size: .8rem; color: #344767; }
.istep small { display: block; font-size: .66rem; color: #8392ab; }
.istep > i { color: #2dce89; }
.istep-no { width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: .75rem; font-weight: 800; color: #1a8f5c; background: #d8f7e9; flex-shrink: 0; }
.istep-static { cursor: default; }
.istep-main { background: linear-gradient(135deg, #2dce89, #1aae6f); border-color: transparent; cursor: pointer; }
.istep-main b, .istep-main small, .istep-main > i { color: #fff; }
.istep-main small { opacity: .85; }
.istep-main .istep-no { background: rgba(255,255,255,.25); color: #fff; }

/* ===== tile kategori ===== */
.cat-strip { display: flex; gap: 10px; overflow-x: auto; padding: 2px 2px 6px; }
.cat-tile { --c: #344767; flex: 0 0 150px; position: relative; text-align: left; border: 2px solid transparent; background: #fff; border-radius: 14px; padding: 10px 12px 12px; box-shadow: 0 3px 10px rgba(52, 71, 103, .06); transition: transform .15s, border-color .15s; overflow: hidden; }
.cat-tile:hover:not(:disabled) { transform: translateY(-2px); }
.cat-tile.on { border-color: var(--c); }
.cat-tile:disabled { opacity: .6; cursor: default; }
.ct-code { display: inline-block; font-size: .65rem; font-weight: 800; color: #fff; background: var(--c); border-radius: 6px; padding: 1px 7px; }
.cat-tile b { display: block; font-size: 1.15rem; color: #344767; margin-top: 4px; }
.cat-tile small { display: block; font-size: .66rem; color: #67748e; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-transform: uppercase; }
.ct-bar { position: absolute; left: 0; right: 0; bottom: 0; height: 4px; background: #eef1f6; }
.ct-bar span { display: block; height: 100%; background: var(--c); }

/* ===== tabel ===== */
.filter-chip { cursor: pointer; }
.item-code { font-family: 'SFMono-Regular', Consolas, monospace; font-size: .72rem; font-weight: 700; color: #344767; background: #f1f3f9; border-radius: 6px; padding: 2px 7px; white-space: nowrap; }
.usage-badge { display: inline-block; font-size: .7rem; font-weight: 800; color: #1a8f5c; background: #d8f7e9; border-radius: 6px; padding: 1px 8px; }
.usage-none { font-size: .65rem; font-weight: 600; color: #c2541f; background: #fff1e6; border-radius: 6px; padding: 1px 7px; }

/* ===== modal import ===== */
::v-deep .modal-import { width: 980px; max-width: 95vw; border-radius: .9rem; }
.drop-zone { display: flex; align-items: center; gap: 14px; border: 2px dashed #b9d8c8; border-radius: 14px; padding: 18px 20px; background: #f7fdf9; cursor: pointer; margin: 0; transition: background .15s, border-color .15s; }
.drop-zone:hover, .drop-zone.dragging { background: #e9f9f0; border-color: #2dce89; }
.drop-zone.filled { border-style: solid; }
.drop-zone > i { font-size: 30px; color: #8fbfa6; }
.drop-zone span { font-size: .85rem; color: #344767; }
.drop-zone small { font-size: .7rem; color: #8392ab; }
.alert-box { background: #fde1e6; color: #b3203f; border-radius: 10px; padding: 10px 14px; font-size: .8rem; }
.preview-summary { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }
.preview-summary > div { display: flex; align-items: baseline; gap: 6px; background: #f4f6fb; border-radius: 10px; padding: 6px 14px; }
.preview-summary b { font-size: 1.2rem; color: #344767; }
.preview-summary span { font-size: .72rem; color: #67748e; }
.preview-summary .ps-ok b { color: #1a8f5c; }
.preview-summary .ps-bad b { color: #d6214a; }
.preview-summary .ps-bad.zero b { color: #8392ab; }
.ps-toggle { font-size: .75rem; color: #67748e; margin: 0 0 0 auto; cursor: pointer; }
.preview-table { max-height: 46vh; overflow: auto; border: 1px solid #e9ecef; border-radius: 10px; margin-top: 10px; }
.preview-table th { position: sticky; top: 0; background: #f4f6fb; font-size: .65rem; text-transform: uppercase; color: #67748e; z-index: 1; }
.preview-table td { font-size: .74rem; color: #344767; vertical-align: top; }
.preview-table tr.row-bad td { background: #fff7f8; }
.status-cell { min-width: 220px; }
.st-ok { color: #1a8f5c; font-weight: 700; }
.st-bad { color: #d6214a; font-size: .7rem; }
.done-icon { width: 64px; height: 64px; border-radius: 50%; margin: 0 auto; display: flex; align-items: center; justify-content: center; font-size: 28px; color: #fff; background: linear-gradient(135deg, #2dce89, #1aae6f); }
.saved-list { max-height: 30vh; overflow: auto; border: 1px solid #e9ecef; border-radius: 10px; }
.saved-row { display: flex; gap: 14px; padding: 6px 12px; font-size: .78rem; border-bottom: 1px solid #f4f5f7; }
.saved-row b { font-family: 'SFMono-Regular', Consolas, monospace; color: #1a8f5c; min-width: 130px; }
</style>
